// src/components/Overlays.js
// Çerez onayı (Google Consent Mode v2) ve PWA yükleme önerisi.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useInstall, promptInstall } from '../pwa/install';

const CONSENT_KEY = 'oyuntu_consent'; // 'all' | 'necessary'
const LEGACY_KEY = 'oyuntu_cookie_ok';
const PWA_KEY = 'oyuntu_pwa_prompt_dismissed';

const store = {
  get: (k) => {
    try {
      return localStorage.getItem(k);
    } catch {
      return null;
    }
  },
  set: (k, v) => {
    try {
      localStorage.setItem(k, v);
    } catch {
      /* depolama kapalı */
    }
  },
};

function applyConsent(choice) {
  const granted = choice === 'all' ? 'granted' : 'denied';
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      ad_storage: granted,
      ad_user_data: granted,
      ad_personalization: granted,
      analytics_storage: granted,
    });
  }
}

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = store.get(CONSENT_KEY) || (store.get(LEGACY_KEY) ? 'all' : null);
    if (choice) return undefined;
    const t = setTimeout(() => setVisible(true), 900);
    return () => clearTimeout(t);
  }, []);

  const decide = (choice) => {
    store.set(CONSENT_KEY, choice);
    applyConsent(choice);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="oy-toast left" role="dialog" aria-live="polite" aria-label="Çerez tercihleri">
      <strong>Çerez tercihleri</strong>
      <p>
        Siteyi çalıştırmak için zorunlu çerezler kullanıyoruz. İzin verirseniz ziyaret istatistikleri ve size uygun reklamlar için Google çerezlerini de kullanırız. <Link to="/oyuntu/gizlilik">Ayrıntılar</Link>
      </p>
      <div className="actions">
        <button type="button" className="oy-btn oy-btn-dark oy-btn-sm" onClick={() => decide('all')}>Kabul et</button>
        <button type="button" className="oy-btn oy-btn-light oy-btn-sm" onClick={() => decide('necessary')}>Yalnızca zorunlu</button>
      </div>
    </div>
  );
}

const SNOOZE_MS = 7 * 24 * 3600 * 1000;

/** Mobilde ve yüklenebilir tarayıcılarda "ana ekrana ekle" bildirimi (reddedilirse 7 gün sonra tekrar). */
export function PWAInstallPrompt() {
  const { canPrompt, ios, mobile, installed } = useInstall();
  const [show, setShow] = useState(false);
  const [help, setHelp] = useState(false);

  useEffect(() => {
    if (installed) return undefined;
    const raw = store.get(PWA_KEY);
    const last = raw === '1' ? Date.now() : Number(raw) || 0; // eski kayıt: kalıcı kapatılmış
    if (last && Date.now() - last < SNOOZE_MS) return undefined;
    // Önce çerez kararı verilmiş olsun ve kullanıcı siteyi biraz gezsin
    const t = setInterval(() => {
      if (!store.get(CONSENT_KEY) || document.querySelector('.gs-canvas canvas')) return; // oyun sırasında gösterme
      if (canPrompt || mobile) setShow(true);
      clearInterval(t);
    }, 12000);
    return () => clearInterval(t);
  }, [canPrompt, mobile, installed]);

  const close = () => {
    store.set(PWA_KEY, String(Date.now()));
    setShow(false);
  };

  const install = async () => {
    const r = canPrompt ? await promptInstall() : 'unavailable';
    if (r === 'unavailable') return setHelp(true);
    close();
  };

  if (!show || installed) return null;
  return (
    <div className="oy-toast" role="dialog" aria-label="Oyuntu'yu yükle">
      <div className="d-flex gap-3 align-items-start">
        <img src="/img/icons/icon-192.png" alt="" width="48" height="48" style={{ borderRadius: 12 }} />
        <div>
          <strong>Oyuntu'yu ana ekrana ekle</strong>
          {help || (ios && !canPrompt) ? (
            ios ? (
              <p>Safari'de <strong>Paylaş</strong> düğmesine, ardından <strong>Ana Ekrana Ekle</strong>'ye dokunun.</p>
            ) : (
              <p>Tarayıcı menüsünden (⋮) <strong>Ana ekrana ekle</strong> ya da <strong>Uygulamayı yükle</strong>'yi seçin.</p>
            )
          ) : (
            <p>Tek dokunuşla aç, tam ekran oyna. Uygulama gibi çalışır, yer kaplamaz.</p>
          )}
          <div className="actions">
            {!(help || (ios && !canPrompt)) && <button type="button" className="oy-btn oy-btn-primary oy-btn-sm" onClick={install}>Yükle</button>}
            <button type="button" className="oy-btn oy-btn-light oy-btn-sm" onClick={close}>{help || ios ? 'Tamam' : 'Şimdi değil'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
